module.exports = __webpack_public_path__ + "img/download.dc7ae7c7.svg";